import React from 'react';
import { Grid } from '@mui/material';

import { BooleanDescField, SimpleTextField, TagsSelectField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function GroupsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={12}>
				{/* TITLE */}
				<SimpleTextField
					name="grps_title"
					label={t('DETAILS_GROUPS_FIELD_TITLE')}
					value={props.model.grps_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* WARNING */}
				<BooleanDescField
					name="grps_warning_desc"
					label={t('DETAILS_GROUPS_FIELD_WARNING')}
					value={props.model.grps_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BLOCKED */}
				<BooleanDescField
					name="grps_blocked_desc"
					label={t('DETAILS_GROUPS_FIELD_BLOCKED')}
					value={props.model.grps_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="grps_tags"
					label={t('DETAILS_GROUPS_FIELD_TAGS')}
					value={props.model.grps_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
